/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import TextField from '@common_forms/TextField';
import Typography from '@common_typography';
import Alert from '@common_alert';
import cx from 'classnames';
import React from 'react';
import Dialog from '@common_dialog';
import { COLORS } from '@theme_vars';
import { getCmsBlocks } from '@core_modules/cms/services/graphql';
import CmsRenderer from '@core_modules/cms/components/cms-renderer';
import Skeleton from '@common_skeleton';
import { getCmsBlocksLazy } from '@core_modules/theme/services/graphql';
import { storeConfigVar } from '@core/services/graphql/cache';

const ModalStoreList = ({
    t, open, handleClose,
    listStores = [], isPdp = false, storeConfig, withLoading = false,
}) => {
    const [stores, setStores] = React.useState(listStores);
    const [search, setSearch] = React.useState('');
    const pwaConfig = storeConfigVar();
    const { widget_general_store_availability } = pwaConfig;

    const { data: dataCMS, loading, error } = getCmsBlocks({ identifiers: ['store_list_floating_action'] });
    const [getCmsBlock, { data: dataCmsStoreList, loading: loadingCmsStoreList, error: errorCmsStoreList }] = getCmsBlocksLazy();
    const content = dataCMS?.cmsBlocks?.items[0]?.content;
    const contentStoreList = dataCmsStoreList?.cmsBlocks?.items[0]?.content;

    const handleSearch = (event) => {
        const { value } = event.target;
        const newItem = listStores.filter(
            ({ name }) => name.toLowerCase().search(value.toLowerCase()) > -1,
        );
        setSearch(value);
        setStores(newItem);
    };

    React.useEffect(() => {
        setStores(listStores);
    }, [listStores]);

    React.useEffect(() => {
        if (open) {
            getCmsBlock({
                variables: { identifiers: [widget_general_store_availability] },
            });
        }
    }, [open]);

    return (
        <Dialog
            open={open}
            closeOnBackdrop
            onClose={() => handleClose()}
            onClickCloseTitle={() => handleClose()}
            title={t('product:storeList:titleModal')}
            useCloseTitleButton
            classWrapperTitle="pb-[5px]"
            classWrapper="w-[100%]"
            classTitle="text-[20px] !text-neutral-black"
            content={(
                <>
                    <div className="flex flex-col">
                        <div className="flex flex-col gap-4 relative h-full">
                            <TextField
                                label={t('product:storeList:searchStore')}
                                value={search}
                                onChange={handleSearch}
                                className="w-full"
                                placeholder={t('product:storeList:searchStore')}
                            />
                            {withLoading ? (
                                [...Array(3)].map(() => (
                                    <Skeleton width="100%" height={100} />
                                ))
                            ) : (
                                <div className="stores_list-wrapper flex flex-col gap-2 relative h-full mb-1 max-h-[50vh] overflow-y-auto">
                                    {
                                        stores.length > 0
                                            ? (
                                                stores.map((item, index) => (
                                                    <div
                                                    // key={item.code}
                                                        key={index}
                                                        className={cx('text-left border border-secondary-600 px-[15px] py-[8px]')}
                                                    >
                                                        <Typography variant="h4" className="!font-bold mb-[5px] !text-neutral-black">
                                                            {item.name}
                                                        </Typography>
                                                        <Typography className="!leading-tight !text-neutral-500 !font-normal">
                                                            {item.street}
                                                            <br />
                                                            {item.city}
                                                            <br />
                                                            {item.region}
                                                            <br />
                                                            {item.country}
                                                            <br />
                                                            {item.postcode}
                                                            <br />
                                                            {item.telephone}
                                                        </Typography>
                                                    </div>
                                                ))
                                            ) : (
                                                <>
                                                    {errorCmsStoreList && (
                                                        <div className="my-5">
                                                            <Alert className="m-15" severity="warning">
                                                                {t('product:storesNotFound')}
                                                            </Alert>
                                                        </div>
                                                    )}
                                                    {content && !loadingCmsStoreList && !errorCmsStoreList && isPdp && (
                                                        <div className="block mb-10">
                                                            <CmsRenderer content={contentStoreList} storeConfig={storeConfig} />
                                                        </div>
                                                    )}
                                                </>
                                            )
                                    }
                                </div>
                            ) }
                        </div>
                    </div>
                    {content && !loading && !error && isPdp && (
                        <div
                            className={cx(
                                'swift-floating_button leading-[0] animate-anima-elastic absolute bottom-0 right-4',
                            )}
                        >
                            <CmsRenderer content={content} storeConfig={storeConfig} />
                        </div>
                    )}
                    <style jsx>
                        {`
                        .stores_list-wrapper::-webkit-scrollbar-track {
                            background: 0 0;
                        }
                        .stores_list-wrapper::-webkit-scrollbar-thumb {
                            background-color: ${COLORS.secondary[600]};
                            border-radius: 8px;
                            border: 1px solid transparent;
                        }
                        .stores_list-wrapper::-webkit-scrollbar {
                            width: 8px;
                        }
                        .stores_list-wrapper {
                            overflow-x: hidden;
                            padding: 0;
                            scrollbar-width: thin;
                            scrollbar-color: ${COLORS.secondary[600]} transparent;
                        }
                    `}
                    </style>
                </>
            )}
        />
    );
};

export default ModalStoreList;
